(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/tipsen-shared/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/sport/tipsen-shared/assets/javascripts/constants.js');
"use strict";


const MatchCorrectStatus = {
  CORRECT: 0,
  NOT_CORRECT: 1,
  POSSIBLE_WIN: 2
};
const MatchResultTypes = {
  NOT_ENTERED: 0,
  ENTERED: 1,
  FINAL: 2,
  VERIFIED: 3
};
const OddsTypes = {
  HIGHEST_ODDS: 'highestOdds',
  LOWEST_ODDS: 'lowestOdds'
};
const ParticipantTypes = {
  Player: 'Player',
  Team: 'Team'
};
const RenderContext = {
  Default: 'default',
  ReduceFree: 'reduceFree',
  ResultOrMybets: 'resultOrMybets'
};
const SvsContactPhoneNumber = '0770-11 11 11';
const WinLevels = {
  LOW: 1000,
  MEDIUM: 20000,
  HIGH: 1000000,
  HIGHEST: 5000000,
  SHOW_ANIMATION_LEVEL: 0
};
const constants = {
  MatchCorrectStatus,
  MatchResultTypes,
  OddsTypes,
  ParticipantTypes,
  RenderContext,
  SvsContactPhoneNumber,
  WinLevels
};
if (svs.isServer) {
  module.exports = constants;
} else {
  setGlobal('svs.components.sport.tipsenShared.constants', constants);
}

 })(window);